export type AcquisitionIntent = 'customer' | 'provider'

const intentKey = 'propertyready.acquisition.intent'
const safePublicStateKey = 'propertyready.native.public-state'

export function saveAcquisitionIntent(intent: AcquisitionIntent) {
  window.localStorage.setItem(intentKey, intent)
}

export function readAcquisitionIntent(value?: string | null): AcquisitionIntent | null {
  if (value === 'customer' || value === 'provider') return value
  const stored = window.localStorage.getItem(intentKey)
  return stored === 'customer' || stored === 'provider' ? stored : null
}

export function saveNativePublicState(path: string) {
  if (isSafeNativePublicPath(path)) window.localStorage.setItem(safePublicStateKey, path)
}

export function readNativePublicState() {
  const stored = window.localStorage.getItem(safePublicStateKey)
  return stored && isSafeNativePublicPath(stored) ? stored : '/welcome'
}

export function isSafeNativePublicPath(path: string) {
  return ['/welcome','/get-service','/contractors','/property-managers','/how-it-works','/sign-in','/sign-up'].includes(path)
}

export function nativePathFromDeepLink(url: string) {
  try {
    const parsed = new URL(url)
    const allowedHost = parsed.protocol === 'propertyready:' || parsed.hostname === 'propertyreadyapp.com' || parsed.hostname === 'www.propertyreadyapp.com'
    if (!allowedHost) return '/welcome'
    const path = parsed.pathname || '/welcome'
    return isSafeNativePublicPath(path) ? path : '/welcome'
  } catch { return '/welcome' }
}
